import axios from 'axios'
import toastStore from '@/stores/toast-store.js'
import sessionStore from '@/stores/session-store.js'
import menuStore from '@/stores/menu-store.js'

export default {
  name: 'SignOutInfo',
  methods: {
    signOut() {
      return axios({
        method: 'delete',
        url: 'auth/sign_out',
        headers: {
          Authorization: `Bearer ${window.localStorage.getItem('collectomate_token')}`,
        },
      })
        .then(() => {
          this.processLogout()
          this.redirectLogOut()
        })
        .catch(error => {
          console.error('error signOut', error)
          toastStore.commit('error', {
            message: 'Sign out failed',
          })
        })
    },
    processLogout() {
      sessionStore.commit('setData', null)
      toastStore.commit('success', {
        message: this.$t('session.successSignOutToast'),
      })
    },
    redirectLogOut() {
      menuStore.commit('close')
      this.$router.push('/')
    },
  },
}
